import type { SelectorItemType } from '@repo/common/components/Selectors/types';

export const DATE_FILTER_OPTIONS = [
	{ value: '24h', label: 'Last 24 hours' },
	{ value: '7d', label: 'Last 7 days' },
	{ value: '30d', label: 'Last 30 days' },
	{ value: '90d', label: 'Last 90 days' },
	{ value: '180d', label: 'Last 180 days' },
	{ value: '365d', label: 'Last year' },
	{ value: 'all', label: 'All time' },
];

export const TIME_SAVINGS_CATEGORIES = [
	{
		key: 'data_discovery_and_search',
		label: 'Discovery & search',
		chartIndex: 1,
	},
	{
		key: 'documentation_and_metadata_management',
		label: 'Documentation & metadata',
		chartIndex: 2,
	},
	{
		key: 'data_governance_and_compliance',
		label: 'Governance & compliance',
		chartIndex: 3,
	},
	{
		key: 'data_quality_and_monitoring',
		label: 'Quality & monitoring',
		chartIndex: 4,
	},
	{
		key: 'process_automation_and_workflows',
		label: 'Automation & workflows',
		chartIndex: 5,
	},
];

export type TimeSavingsCategoryKey =
	(typeof TIME_SAVINGS_CATEGORIES)[number]['key'];

export const SORT_OPTIONS: SelectorItemType[] = [
	{ value: 'newest', label: 'Most recent' },
	{ value: 'oldest', label: 'Oldest' },
];

export const AI_PROMPTS_BY_MEMBER_SORT_OPTIONS: SelectorItemType[] = [
	{ value: 'most_active', label: 'Most active' },
	{ value: 'least_active', label: 'Least active' },
];

export const AI_IMPACT_DASHBOARD_WIDGETS_HEIGHT = 230;
